import React from 'react';

import styled from 'styled-components';
import {
  LTButton,
  LTTestStatusLabel,
  LTText,
  LTTooltip,
} from '@lambdatestincprivate/lt-components';
import { Link, useNavigate } from 'react-router-dom';

import { ArrowRight } from '../../../assets/arrowIcons/arrow-right';

import styles from './index.module.css';
import { useAutomationContext } from '../../../../../TestPageWeb/src/components/AutomationLogsPageWrapper';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBrandName,
  getUrlByUserDomain,
} from '../../../utils/utilityFunctions';
import { getEnvVar } from '../../../utils/env';
const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const BuildDetails = styled(Flex)`
  width: 100%;
`;

const TestDetailsHeader = styled(Flex)`
  width: 100%;
  justify-content: space-between;
`;

const PrimaryHeader = ({
  isLtAccessibilityEnabled = false,
  statusIconSrc = '',
  headerActions,
  remarkList = [],
  isSampleBuild,
  isHeaderBtnInjectedByOtherProduct,
  showHeaderBtn,
  handleHeaderBtnClick = () => {},
  testDetail,
}) => {
  let {
    buildId = '',
    status = 'passed',
    buildName: title = '',
    name = '',
    id = '',
  } = testDetail || {};

  const heading = name || id;

  const urlData = decodeBase64Params(window.location.href);

  let stageName = urlData?.stageName;
  if(stageName === 'undefined' || stageName === 'null') {
    stageName = '';
  }

  const encodedTitle = encodeURIComponent(title);

  const {  fromHyperExecute, buildButtonText, onBuildButtonClick } = useAutomationContext();
  const tooltipText = buildButtonText ? `Go to ${buildButtonText} page` : 'Go To Build Page';
  const buttonText = buildButtonText ? buildButtonText : 'Builds';

  const findDesiredLog = (key, value, array) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  };

  function decodeBase64Params(url) {
    const parsedUrl = new URL(url);
    const base64Data = parsedUrl.searchParams.get('details');
    if (!base64Data) return {};

    const jsonString = atob(decodeURIComponent(base64Data));
    return JSON.parse(jsonString);
  }

  function handleHeaderButtonClick() {
    if (typeof onBuildButtonClick === 'function') {
      onBuildButtonClick();
    } else {
      handleHeaderBtnClick();
    }
  }

  const handleRedirectToHypertestStage = () => {
    const brandNameInUrl = getBrandName();
    const origin = window.location.origin;

    let endPointPrefix =
      getEnvVar('REACT_APP_HYPERTEST_ENDPOINT_PREFIX') ||
      window?._env_?.REACT_APP_HYPERTEST_ENDPOINT_PREFIX;
    if (origin.includes('beta-') || origin.includes('dev.hyperexecute')) {
      endPointPrefix = `beta-${endPointPrefix}`;
    }

    const urlPrefix = brandNameInUrl
      ? `${getUrlByUserDomain(`${endPointPrefix}.${brandNameInUrl}`)}`
      : getUrlByUserDomain(endPointPrefix);

    const urlData = decodeBase64Params(window.location.href);
    const jobIdParam = urlData.jobId;
    const taskIdParam = urlData.taskId;
    const order = urlData.order;
    const link = urlData.link;

    window.location.href = `${urlPrefix}/hyperexecute/task?jobId=${jobIdParam}&taskId=${taskIdParam}&logType=scenario&order=${order}&link=${link}`;
  };

  const isTestMuted = testDetail?.feature_flag?.isMuted;
  const headerTitle = stageName ? decodeURIComponent(stageName) : title;
  return (
    <>
      <div style={{ width: '100%' }}>
        <BuildDetails>
          {showHeaderBtn && !fromHyperExecute && (
            <>
              <LTTooltip
                direction={LTTooltip.Direction.BOTTOM}
                text={tooltipText}
              >
                <LTButton
                  aria-label={`Go To ${buttonText}`}
                  alt={buttonText}
                  className={
                    isLtAccessibilityEnabled
                      ? styles.goBackToBuildsHighContrast
                      : ''
                  }
                  data-testid="back-to-build-btn"
                  id="back-to-build-button"
                  onClick={handleHeaderButtonClick}
                  variant={LTButton.Variant.INVISIBLE}
                >
                  {buttonText}
                </LTButton>
              </LTTooltip>
              <ArrowRight iconColor="#636C76" />
            </>
          )}
          <LTTooltip
            text={headerTitle}
            customTriggerStyle={{
              overflow: 'hidden',
            }}
          >
            {showHeaderBtn &&
            !isSampleBuild &&
            !isHeaderBtnInjectedByOtherProduct ? (
              <Link
                id="parentBuildLink"
                data-testid="test-summary-build-name"
                className={`${styles.buildName} ${
                  isLtAccessibilityEnabled ? styles.buildNameHighContrast : ''
                }`}
                style={{ overflow: 'hidden' }}
                to={`/build?pageType=test&buildName=${encodedTitle}&build=${buildId}`}
              >
                <LTText
                  variant={LTText.TextVariant.SUBHEADER_REGULAR}
                  style={{
                    wordBreak: 'break-all',
                    marginLeft: '4px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    display: 'block',
                    textOverflow: 'ellipsis',
                  }}
                  color="fg.muted"
                >
                  {title}
                </LTText>
              </Link>
            ) : (
              <LTText
                id="parentBuildName"
                data-testid="test-summary-build-name"
                variant={LTText.TextVariant.SUBHEADER_REGULAR}
                style={{
                  wordBreak: 'break-all',
                  marginLeft: '4px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'block',
                  textOverflow: 'ellipsis',
                }}
                color="fg.muted"
              >
                {headerTitle}
              </LTText>
            )}
          </LTTooltip>
        </BuildDetails>
        <TestDetailsHeader>
          <Flex style={{ overflow: 'hidden' }}>
            <Flex
              style={{
                marginRight: '8px',
              }}
              id="testStatus"
            >
              <LTTestStatusLabel
                iconSrc={statusIconSrc}
                status={status}
                width="20"
                height="20"
              />
            </Flex>
            <LTTooltip
              text={heading}
              customTriggerStyle={{
                overflow: 'hidden',
              }}
            >
              <LTText
                id="testName"
                data-testid="test-summary-test-name"
                variant={LTText.TextVariant.HEADER_BOLD}
                style={{
                  wordBreak: 'break-all',
                  marginRight: '8px',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                }}
                color={isTestMuted ? 'fg.muted' : 'fg.default'}
              >
                {heading}
              </LTText>
            </LTTooltip>
          </Flex>
          {headerActions ? (
            <Flex id="headerAction" style={{ gap: '8px', width: 'auto' }}>
              {headerActions}
            </Flex>
          ) : null}
        </TestDetailsHeader>
      </div>
      {remarkList?.map((remark) => (
        <div style={{ width: '100%' }}>{remark}</div>
      ))}
    </>
  );
};

export default PrimaryHeader;
